import { Action, createReducer, on } from '@ngrx/store';
import { initialState, LiveClassState } from './live-class.state';

import * as LiveClassActions from './live-class.action';

const liveClassReducer = createReducer(
  initialState,
  on(LiveClassActions.initiateLiveClassCreation, (state) => {
    return {
      ...state,
      createdLiveClassItem: null,
    };
  }),
  on(LiveClassActions.createLiveClassSuccess, (state, { liveClass }) => {
    return {
      ...state,
      createdLiveClassItem: liveClass,
    };
  }),
  on(
    LiveClassActions.fetchAllLiveClassesSuccess,
    (state, { response, forInstructor }) => {
      const { docs, ...pagination } = response;

      if (forInstructor) {
        return {
          ...state,
          instructorLiveClasses: docs,
          pagination,
        };
      }

      return {
        ...state,
        liveClassItems: docs,
        pagination,
      };
    }
  ),
  on(LiveClassActions.restoreLiveClassItemSuccess, (state, { item }) => {
    return {
      ...state,
      createdLiveClassItem: item,
    };
  }),
  on(LiveClassActions.updateLiveClassSuccess, (state, { liveClass }) => {
    return {
      ...state,
      createdLiveClassItem: liveClass,
    };
  }),
  on(LiveClassActions.requestForReviewSuccess, (state, { liveClass }) => {
    return {
      ...state,
      createdLiveClassItem: liveClass,
    };
  }),
  on(LiveClassActions.publishLiveClassSuccess, (state, { liveClass }) => {
    return {
      ...state,
      createdLiveClassItem: liveClass,
    };
  }),
  on(LiveClassActions.selectLiveClassSuccess, (state, { liveClass }) => {
    return {
      ...state,
      selectedLiveClassItem: liveClass,
    };
  }),
  on(LiveClassActions.subscribeToLiveClass, (state) => {
    return {
      ...state,
      subscription: null,
    };
  }),
  on(LiveClassActions.subscribeToLiveClassSuccess, (state, { invoice }) => {
    return {
      ...state,
      subscription: {
        invoice: invoice ?? null,
        processingPayment: false,
        paymentSuccess: false,
        error: null,
      },
    };
  }),

  on(LiveClassActions.processPayment, (state) => {
    return {
      ...state,
      subscription: {
        invoice: state.subscription?.invoice ?? null,
        paymentSuccess: false,
        processingPayment: true,
        error: null,
      },
    };
  }),
  on(LiveClassActions.processSuccess, (state, { invoice }) => {
    return {
      ...state,
      subscription: {
        invoice: invoice,
        processingPayment: false,
        paymentSuccess: true,
        error: null,
      },
    };
  }),

  on(LiveClassActions.processPaymentFailed, (state, { err }) => {
    return {
      ...state,
      subscription: {
        invoice: state.subscription?.invoice ?? null,
        paymentSuccess: false,
        processingPayment: false,
        error: err.message,
      },
    };
  }),
  on(LiveClassActions.fetchInvoice, (state) => {
    return {
      ...state,
      subscription: {
        invoice: null,
        paymentSuccess: state.subscription?.processingPayment ?? false,
        processingPayment: state.subscription?.processingPayment ?? false,
        error: null,
      },
    };
  }),
  on(LiveClassActions.fetchInvoiceSuccess, (state, { invoice }) => {
    return {
      ...state,
      subscription: {
        invoice: invoice,
        paymentSuccess: state.subscription?.processingPayment ?? false,
        processingPayment: state.subscription?.processingPayment ?? false,
        error: null,
      },
    };
  }),
  on(
    LiveClassActions.fetchSubscribedLiveClassesSuccess,
    (state, { subscribedLiveClasses }) => {
      return {
        ...state,
        subscribedLiveClasses: subscribedLiveClasses,
      };
    }
  )

  // TODO : handle api fail cases
);

export function reducer(state: LiveClassState | undefined, action: Action) {
  return liveClassReducer(state, action);
}
